// App Imports
import params from '../../../setup/config/params'
import List from '../List'
import Detail from '../Detail'
import Update from '../Update'
import Unsubscribed from '../Unsubscribed/index'
import { IMAGE_SOURCE_PATH } from '../../../setup/config/env'
import { defaultImage } from '../../common/Sidebar';


export function getImageSource(image = defaultImage) {
  return `${ IMAGE_SOURCE_PATH }${ image }`
}

// Pages routes
const routes = {
  customerUnsubscribed: {
    path: '/customers/unsubscribed',
    exact: true,
    component: Unsubscribed,
    auth: true,
    role: params.user.roles.admin.key,
    module: "store",
    subModule: "customers",
    action: "canView",
  },

  customerList: {
    path: (page = ':page') => `/customers/${ page }`,
    activePath: '/customer',
    component: List,
    auth: true,
    role: params.user.roles.admin.key,
    module: "store",
    subModule: "customers",
    action: "canView",
  },

  customerDetail: {
    path: (userId = ':userId') => (`/customer/detail/${ userId }`),
    component: Detail,
    auth: true,
    role: params.user.roles.admin.key,
    module: "store",
    subModule: "customers",
    action: "canView",
  },

  customerUpadte: {
    path: (userId = ':userId') => (`/customer/edit/${ userId }`),
    component: Update,
    auth: true,
    role: params.user.roles.admin.key,
    module: "store",
    subModule: "customers",
    action: "canEdit",
  }
}
export default routes;